import { Controller } from "@hotwired/stimulus"
import { SWITCH_SLIDE_MS, suppressProgressBar } from "../lib/helpers"

export default class extends Controller {
  static targets = ["circle"]
  static values = {enabled: Boolean}

  connect() {
    this.boundSettle = this.settle.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSettle)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundSettle)
    clearTimeout(this.timer)
    if (this.sliding && !this.armed) {
      document.dispatchEvent(new CustomEvent("fsp:decrement"))
    }
  }

  // A same-URL redirect keeps this instance, so reset for the next click, unless a new slide holds refreshes.
  settle() {
    if (this.sliding && !this.armed) return
    clearTimeout(this.timer)
    this.armed = false
    this.sliding = false
  }

  slide(event) {
    if (this.armed) return // delayed requestSubmit: let native submit through
    event.preventDefault()
    if (this.sliding) return

    this.sliding = true
    document.dispatchEvent(new CustomEvent("fsp:increment"))

    this.circleTarget.dataset.state = this.enabledValue ? "pending-off" : "pending-on"

    this.timer = setTimeout(() => {
      this.armed = true
      document.dispatchEvent(new CustomEvent("fsp:decrement"))
      suppressProgressBar()
      this.element.requestSubmit()
    }, SWITCH_SLIDE_MS)
  }
}
